import React, { useEffect, useState } from "react";

const ENVIRONMENT_LABELS = {
  dev: "Dev",
  development: "Dev",
  sandbox: "Sandbox",
  staging: "Staging",
  preview: "Preview",
  local: "Local",
};

export const formatBuildVersion = (metadata) => {
  if (!metadata || typeof metadata !== "object") return "";

  const environment = String(metadata.environment || "").toLowerCase();
  const environmentLabel = ENVIRONMENT_LABELS[environment] || "";
  const releaseVersion = String(metadata.version || "").replace(/^v/i, "");
  const rawBuildId = String(
    metadata.shortBuildId || metadata.buildId || "",
  ).trim();
  const buildId = rawBuildId ? rawBuildId.slice(0, 9) : "";

  return [
    environmentLabel,
    releaseVersion ? `v${releaseVersion}` : "",
    buildId,
  ]
    .filter(Boolean)
    .join(" · ");
};

export const fetchBuildVersion = async () => {
  const publicUrl = process.env.PUBLIC_URL || "";
  const response = await fetch(`${publicUrl}/version.json?t=${Date.now()}`, {
    cache: "no-store",
  });
  if (!response.ok) return null;
  return response.json();
};

export default function BuildVersionLabel() {
  const [label, setLabel] = useState("");

  useEffect(() => {
    let cancelled = false;

    fetchBuildVersion()
      .then((metadata) => {
        if (!cancelled) setLabel(formatBuildVersion(metadata));
      })
      .catch(() => {
        // Version metadata is diagnostic only; never disrupt account access.
      });

    return () => {
      cancelled = true;
    };
  }, []);

  if (!label) return null;

  return (
    <div
      className="cp-dropdown-version"
      title={label}
      aria-label={`App ${label}`}
    >
      {label}
    </div>
  );
}
